<template>
  <svg width="16"
       height="18"
       viewBox="0 0 16 18"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M7.95605 17.5928C8.11426 17.5928 8.34277 17.5312 8.57129 17.417C13.6074 14.8242 15.2773 13.4619 15.2773 10.3066V3.77637C15.2773 2.73926 14.873 2.36133 14.0029 2.00098C13.0361 1.59668 9.81934 0.462891 8.87891 0.146484C8.58887 0.0585938 8.26367 -0.00292969 7.95605 -0.00292969C7.65723 -0.00292969 7.33203 0.0585938 7.04199 0.146484C6.09277 0.445312 2.87598 1.60547 1.91797 2.00098C1.04785 2.35254 0.643555 2.73926 0.643555 3.77637V10.3066C0.643555 13.4619 2.38379 14.7012 7.34961 17.417C7.57812 17.54 7.80664 17.5928 7.95605 17.5928ZM4.68652 11.8447V8.29395C4.68652 7.66992 4.94141 7.34473 5.45117 7.29199V6.27246C5.45117 4.59375 6.4707 3.45996 7.95605 3.45996C9.4502 3.45996 10.4697 4.59375 10.4697 6.27246V7.29199C10.9795 7.34473 11.2344 7.66992 11.2344 8.29395V11.8447C11.2344 12.5479 10.918 12.8643 10.2764 12.8643H5.64453C5.00293 12.8643 4.68652 12.5479 4.68652 11.8447ZM6.54102 7.27441H9.37988V6.17578C9.37988 5.17383 8.80859 4.51465 7.95605 4.51465C7.10352 4.51465 6.54102 5.18262 6.54102 6.17578V7.27441Z"
          :fill="color"/>
  </svg>

</template>
<script>
export default {
  name: 'HabeasIcon',
  props: {
    width: {
      type: Number,
      default: 11
    },
    height: {
      type: Number,
      default: 12
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>
